import { render, staticRenderFns } from "./Errorpage.vue?vue&type=template&id=059adf43&scoped=true&"
import script from "./Errorpage.vue?vue&type=script&lang=js&"
export * from "./Errorpage.vue?vue&type=script&lang=js&"
import style0 from "./Errorpage.vue?vue&type=style&index=0&id=059adf43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059adf43",
  null
  
)

export default component.exports